import { InjectionToken } from '@angular/core';

export const APPLICATION_CONFIG_PATH_TOKEN = new InjectionToken<string>('APPLICATION_CONFIG_PATH');
